import { configureStore } from "@reduxjs/toolkit";
import betslip from "./betslip";
import filter from "./filter";
import view from "./view";
import favourites from "./favourites";

export const reducers = {
  betslip,
  filter,
  view,
  favourites,
};

const store = configureStore({
  reducer: reducers,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
